import axiosInstance from "./config/axiosConfigs";
import { getToken } from "../cookie/authCookie";



export const PrivilegeAPI = {
    getAllPrivilegesByFeature: async function (reqObj) {
        const response = await axiosInstance.request({
            url: `/privileges-by-feature`,
            method: "POST",
            withCredentials: true,
            timeout: 20000,
            data:reqObj,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
    getAllPrivilegesForSideBar: async function (userId) {
        const response = await axiosInstance.request({
            url: `/privilege/sidebar/${userId}`,
            method: "GET",
            withCredentials: true,
            timeout: 20000,
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        return response.data;
    },
}